'use client'

import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { FUEL_TAP_EVENTS } from '@constants/fuelEvents'
import { getStateAndCity } from '@helpers/fuelPageHelpers'
import { fuelSegmentEventCommonPropFunc } from '@utils/segmentProperties'
import Image from 'next/image'
import { APPSTORE_LINK, DOWNLOAD_ANDROID_APP, DOWNLOAD_IOS_APP, PLAYSTORE_LINK } from '../constants/texts'

const ImageDoMoreAcko = ({ location, fuelType, parsedLocationIsState, mappedStateWithCities, stateCode }) => {
  const handleAppStore = async (eventName, redirectionUrl) => {
    const fuelSegmentCommonProperties = await fuelSegmentEventCommonPropFunc()
    await trackEvent(eventName, {
      state_name: parsedLocationIsState ? location : getStateAndCity(location, mappedStateWithCities, stateCode),
      city_name: location,
      fuel_type: fuelType,
      ...fuelSegmentCommonProperties,
    })
      .then(() => {})
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        window.open(redirectionUrl, '_blank')
      })
  }

  return (
    <>
      <Image
        height={40}
        width={125}
        src={DOWNLOAD_IOS_APP}
        alt="Fuel Download IOS Acko app"
        layout="fixed"
        // eslint-disable-next-line react/no-string-refs
        onClick={e => {
          e.preventDefault()
          void handleAppStore(FUEL_TAP_EVENTS.TAP_APPSTORE, APPSTORE_LINK)
        }}
      />
      <Image
        height={40}
        width={125}
        src={DOWNLOAD_ANDROID_APP}
        alt="Fuel Download Android Acko app"
        layout="fixed"
        // eslint-disable-next-line react/no-string-refs
        onClick={e => {
          e.preventDefault()
          void handleAppStore(FUEL_TAP_EVENTS.TAP_PLAYSTORE, PLAYSTORE_LINK)
        }}
      />
    </>
  )
}

export default ImageDoMoreAcko
